import { defineStore } from 'pinia'

export const useInstructionStore = defineStore('instruction', {
    state: () => ({
        visible: false,
    }),

    actions: {
        showIfNeeded() {
            if (!localStorage.getItem('instruction_seen')) {
                this.visible = true
            }
        },

        close() {
            this.visible = false
        },

        finish() {
            localStorage.setItem('instruction_seen', 'true')
            this.visible = false
        }
    }
})
